const baseFitmentFields = window.Convermax.config?.baseFitmentFields || ['Year', 'Make', 'Model'];
const extraFitmentFields = window.Convermax.config?.extraFitmentFields || ['Submodel'];

const categorySelectionPageUrl = '/shop-by-category/';

async function getSelectedVariantId(productForm, productId) {
  const formData = new FormData(productForm);
  formData.set('action', 'add');
  formData.set('product_id', productId);

  if (![...formData.keys()].some((name) => name === 'qty[]' || name === 'qty')) {
    formData.set('qty', '1');
  }

  const response = await fetch(`/remote/v1/product-attributes/${productId}`, {
    method: 'POST',
    body: formData,
  });
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }

  const data = await response.json();
  return data.data?.v3_variant_id;
}

function initVerifyFitmentVariant() {
  const productForm = document.querySelector('form[data-cart-item-add]');
  const productId = productForm?.querySelector('input[name="product_id"]')?.value;
  if (!productForm || !productId || !productForm.querySelector('[data-product-option-change]')) {
    return;
  }

  let requestNumber = 0;
  const updateVariant = async () => {
    const currentRequest = ++requestNumber;

    try {
      const variantId = await getSelectedVariantId(productForm, productId);
      if (currentRequest === requestNumber) {
        window.Convermax.updateVerifyFitmentWidget(variantId ? `variant-${variantId}` : productId);
      }
    } catch (error) {
      if (currentRequest === requestNumber) {
        window.Convermax.updateVerifyFitmentWidget(productId);
      }

      console.warn('[Convermax] Failed to update verify fitment variant.', error);
    }
  };

  updateVariant();
  productForm.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-product-option-change]')) {
      updateVariant();
    }
  });
}

function InitFunc() {
  const convermaxPages = ['/search/', categorySelectionPageUrl];

  if (convermaxPages.includes(window.location.pathname)) {
    const centered = window.document.querySelector('.page-content.page-content--centered');
    if (centered) {
      centered.classList = '';
    }
  }

  initVerifyFitmentVariant();
}

export default {
  platform: 'bigcommerce',
  InitFunc,
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [{ pathname: categorySelectionPageUrl, field: 'category' }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: 'main.pages-category .page-content, main.pages-brand .page-content',
      template: 'MainContent',
    },
    {
      name: 'FacetPanelCategory',
      type: 'FacetPanel',
      location: 'main.pages-category .page-sidebar, main.pages-brand .page-sidebar',
      template: 'FacetPanelContainer',
    },
    {
      name: 'SearchHeader',
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'CategoryPageCategoriesCarousel',
      type: 'FacetTiles',
      location: '#subcategories-section',
      template: 'facetTiles/subtitles',
      view: 'carousel',
      facetField: 'category',
    },
    {
      name: 'FacetPanel',
    },
    {
      name: 'SearchBox',
      location: { replace: '.header-search form.form' },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertBefore: '.navUser-item--account',
        wrapper: 'li',
        class: 'navUser-item cm_search-box-root__dialog_open-button_container',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-home-ymm',
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 900,
      useSearchableDropdown: true,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      columnBreakpoint: 550,
      useSearchableDropdown: true,
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '.navUser-item--account',
        wrapper: 'li',
        class: 'navUser-item cm_garage_container',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_category-list',
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertAfter: 'main.pages-product .productView-details.product-data',
        class: 'productView-details',
      },
      template: 'fitmentSearch/verifyFitment',
      useSearchableDropdown: true,
    },
    {
      name: 'FitmentTable',
      location: {
        lastChildOf: '.productView-description #tab-description',
      },
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
      useSearchableDropdown: true,
    },
  ],
};
